import React from "react";
import { Button } from "@glamcorner/components/lib/core/components/Button";
import "./rental-periods.scss";

export type RentalPeriodsProps = {
  selectedDays: number;
  onSelect: (rentalDays: number) => void;
  rentalDays: number[];
};

export const RentalPeriods: React.FC<RentalPeriodsProps> = ({ selectedDays, onSelect, rentalDays }) => {
  return (
    <div className="c-rental-periods">
      {rentalDays.sort().map((days) => {
        return (
          <Button
            key={`rental-${days}`}
            text={`${days} - Day Rental`}
            className="c-rental-period__button"
            buttonType={selectedDays === days ? "primary" : "secondary"}
            onClick={() => onSelect(days)}
          />
        );
      })}
    </div>
  );
};
